module.exports = __webpack_public_path__ + "static/media/hn-cau-giay.c636d747.svg";